import { Skeleton } from "@chakra-ui/react";

const ChartCard = ({
  title,
  subtitle,
  action,
  loading,
  empty,
  emptyText = "لا توجد بيانات في هذه الفترة",
  height = 280,
  children,
  className = "",
}) => {
  return (
    <div
      className={`flex flex-col gap-4 rounded-2xl border border-border-muted bg-white p-5 shadow-card dark:border-navy-700 dark:bg-navy-800 ${className}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          {title ? (
            <h3 className="text-base font-semibold text-navy-700 dark:text-white">
              {title}
            </h3>
          ) : null}
          {subtitle ? (
            <p className="mt-1 text-xs text-gray-500">{subtitle}</p>
          ) : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>

      <div className="relative" style={{ minHeight: height }}>
        {loading ? (
          <Skeleton height={`${height}px`} borderRadius="14px" />
        ) : empty ? (
          <div
            className="flex h-full w-full items-center justify-center text-sm text-gray-500"
            style={{ minHeight: height }}
          >
            {emptyText}
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default ChartCard;
